import styles from "./Page.module.css";

interface PageProps {
  title: string;
  children: React.ReactNode;
  subtle?: boolean;
  className?: string;
}

export const Page = ({
  title,
  children,
  subtle = false,
  className = "",
}: PageProps) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {title && (
        <header className={styles.header}>
          <h1 className={subtle ? styles.subtleTitle : styles.title}>
            {title}
          </h1>
        </header>
      )}
      <main className={styles.body}>{children}</main>
    </div>
  );
};
